// Aquí están los thunks relacionados con seguidores
import { createAsyncThunk } from "@reduxjs/toolkit";
import store from "@/app/store";
import api from "@/services/api";
import {
  seguidoresSuccess,
  seguidoresFailure,
  seguidoresReset,
  crearSeguidorSuccess,
  eliminarSeguidorSuccess,
} from "./seguidoresSlice";

/**
 * 📝 SEGUIDORES — Obtiene los seguidores de un usuario
 */
export const getSeguidores = createAsyncThunk(
  "seguidores/getSeguidores",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const state = store.getState();
      const uid = state.auth.user?.uid;
      
      if (!uid) {
        throw new Error("UID de usuario no disponible");
      }
      const { data } = await api.get(`/seguidores/${uid}`);
      
      dispatch(seguidoresSuccess({ seguidoresInfo: data }));
      return data;
    } catch (err) {
      console.error("Error al obtener seguidores:", err);
      dispatch(
        seguidoresFailure(
          err.response?.data ||
            err.response?.data?.message ||
            "Error de seguidores"
        )
      );
      return rejectWithValue(
        err.response?.data ||
          err.response?.data?.message ||
          "Error de seguidores"
      );
    }
  }
);

/**
 * 📝 SEGUIDORES — Crea un seguidor (usuario sigue a otro usuario)
 */
export const crearSeguidor = createAsyncThunk(
  "seguidores/crearSeguidor",
  async ({ uidSeguido }, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await api.post(`/seguidores/usuario/${uidSeguido}`);
      dispatch(crearSeguidorSuccess({ uidSeguido }));
      return data;
    } catch (err) {
      console.error("Error al seguir usuario:", err);
      return rejectWithValue(
        err.response?.data ||
          err.response?.data?.message ||
          "Error al seguir usuario"
      );
    }
  }
);

/**
 * 📝 SEGUIDORES — Elimina un seguidor (usuario deja de seguir a otro usuario)
 */
export const eliminarSeguidor = createAsyncThunk(
  "seguidores/eliminarSeguidor",
  async ({ uidSeguido }, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await api.delete(`/seguidores/usuario/${uidSeguido}`);
      dispatch(eliminarSeguidorSuccess({ uidSeguido }));
      return data;
    } catch (err) {
      console.error("Error al dejar de seguir usuario:", err);
      return rejectWithValue(
        err.response?.data ||
          err.response?.data?.message ||
          "Error al dejar de seguir usuario"
      );
    }
  }
);

/**
 * 📝 SEGUIDORES — Obtiene los seguidores de una empresa
 */
export const getSeguidoresEmpresa = createAsyncThunk(
  "seguidores/getSeguidoresEmpresa",
  async ({ empresaUid }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/seguidores/empresa/${empresaUid}`);
      return data;
    } catch (err) {
      console.error("Error al obtener seguidores de empresa:", err);
      return rejectWithValue(
        err.response?.data ||
          err.response?.data?.message ||
          "Error al obtener seguidores de empresa"
      );
    }
  }
);

/**
 * 📝 SEGUIDORES — Sigue a una empresa
 */
export const seguirEmpresa = createAsyncThunk(
  "seguidores/seguirEmpresa",
  async ({ empresaUid }, { rejectWithValue }) => {
    try {
      const { data } = await api.post(`/seguidores/empresa/${empresaUid}`);
      return data;
    } catch (err) {
      console.error("Error al seguir empresa:", err);
      return rejectWithValue(
        err.response?.data ||
          err.response?.data?.message ||
          "Error al seguir empresa"
      );
    }
  }
);

/**
 * 📝 SEGUIDORES — Deja de seguir a una empresa
 */
export const dejarDeSeguirEmpresa = createAsyncThunk(
  "seguidores/dejarDeSeguirEmpresa",
  async ({ empresaUid }, { rejectWithValue }) => {
    try {
      const { data } = await api.delete(`/seguidores/empresa/${empresaUid}`);
      return data;
    } catch (err) {
      console.error("Error al dejar de seguir empresa:", err);
      return rejectWithValue(
        err.response?.data ||
          err.response?.data?.message ||
          "Error al dejar de seguir empresa"
      );
    }
  }
);
